const mediaQueries = {
    'xs-up': '(min-width: 0px)',
    'xs-down': '(max-width: 575px)',
    'sm-up': '(min-width: 576px)',
    'sm-down': '(max-width: 767px)',
    'md-up': '(min-width: 768px)',
    'md-down': '(max-width: 991px)',
    'lg-up': '(min-width: 992px)',
    'lg-down': '(max-width: 1199px)'
  };
  
  const mediaQuery = mq => {
    const equaliseAt = mq ?? 'xs-up';
  
    return mediaQueries[equaliseAt] ?? mediaQueries['xs-up'];
  };
  
  export { mediaQueries, mediaQuery };
  